import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const checkBoxList = [
  {
    label: "はい",
  },
];
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "中小企業退職共済契約締結年月日",
    keyword: "contractDate",
    type: "text",
  },
  {
    title: "中小企業退職共済契約者番号",
    keyword: "contractNo",
    type: "text",
  },
  {
    title: "締結の理由",
    keyword: "contractReason",
    type: "text",
  },
  {
    title: "備考",
    keyword: "remark",
    type: "text",
  },
];

const fakeTableListSecond: ITkFakeTableLineProps[] = [
  {
    title: "従業状況は最新の状況になっていますか？",
    keyword: "employeeStatusCheckbox",
    type: "nodeInLine",
  },
  {
    title: "施設テーブル",
    keyword: "facilitySituationTable",
    type: "node",
  },
  {
    title: "メモと処理状況一覧",
    keyword: "memo",
    type: "node",
  },
];

const smeGratuitySession: ITkFakeTableLineProps[] = [
  {
    title: "中小企業退職金共済契約締結届",
    keyword: "SMEGratuitySession",
    type: "node",
  },
];

const headList = [
  {
    headTitle: "担当者",
  },
  {
    headTitle: "処理",
  },
  {
    headTitle: "実施日",
  },
  {
    headTitle: "コメント",
  },
];

const infoHeadTitleList: any[] = [
  {
    headTitle: "施設名称",
  },
  {
    headTitle: "施設種類",
  },
  {
    headTitle: "加入職員数",
  },
  {
    headTitle: "従業状況確認",
    dontNeedSort: true,
  },
  {
    headTitle: "直近３か月の退職者の証明書",
    dontNeedSort: true,
  },
];

const schema = {};

export {
  fakeTableList,
  fakeTableListSecond,
  smeGratuitySession,
  headList,
  infoHeadTitleList,
  checkBoxList,
  schema,
};
